import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
/** ====== services ====== */
import { AuthGuard } from './services/auth-guard.service'

const routes: Routes = [
  
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full'
  },
  {
    path: 'index',
    loadChildren: () => import('./pages/index/index.module').then( m => m.IndexPageModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./pages/signin/signin.module').then( m => m.SigninPageModule)
  },
  {
    path: 'password-reset',
    loadChildren: () => import('./pages/password-reset/password-reset.module').then( m => m.PasswordResetPageModule)
  },
  {
    path: 'home',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'settings',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'sql-table/:table/:display',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/sql-table/sql-table.module').then( m => m.SqlTablePageModule)
  },
  {
    path: 'language',
    loadChildren: () => import('./pages/settings/language/language.module').then( m => m.LanguagePageModule)
  },
  {
    path: 'programme/:programmeId',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/programme/programme.module').then( m => m.ProgrammePageModule)
  },
  {
    path: 'faq/:programmeId',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/faq/faq.module').then( m => m.FaqPageModule)
  },
  {
    path: 'new-assessment/:programmeId/:formId',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/new-assessment/new-assessment.module').then( m => m.NewAssessmentPageModule)
  },
  {
    path: 'assessment-change-unit/:programmeId/:formId/:assessmentId/:action',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/new-assessment/new-assessment.module').then( m => m.NewAssessmentPageModule)
  },
  {
    path: 'assessment/:id',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/assessment/assessment.module').then( m => m.AssessmentPageModule)
  },
  {
    path: 'assessment-list/:programmeId',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/assessment-list/assessment-list.module').then( m => m.AssessmentListPageModule)
  },
  {
    path: 'assessment-history/:programmeId',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/assessment-history/assessment-history.module').then( m => m.AssessmentHistoryPageModule)
  },
  {
    path: 'assessment-returned/:programmeId/:id',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/assessment-returned/assessment-returned.module').then( m => m.AssessmentReturnedPageModule)
  },
  {
    path: 'storage',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7/:t8',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7/:t8/:t9',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7/:t8/:t9/:t10',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7/:t8/:t9/:t10/:t11',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'storage/:t1/:t2/:t3/:t4/:t5/:t6/:t7/:t8/:t9/:t10/:t11/:t12',
    canActivate : [ AuthGuard ],
    loadChildren: () => import('./pages/settings/storage/storage.module').then( m => m.StoragePageModule)
  },
  {
    path: 'proofing/assessment/:programmeId/:id',
    loadChildren: () => import('./pages/proofing/assessment/assessment.module').then( m => m.AssessmentPageModule)
  },
  {
    path: 'proofing/assessment-loader/:programmeId/:id/:locale',
    loadChildren: () => import('./pages/proofing/assessment-loader/assessment-loader.module').then( m => m.AssessmentLoaderPageModule)
  },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
